// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class NoticeModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get getNoticeType() {
    switch (this.instance["options"]["type"]) {
      case "info":
        return "info";
      case "alert":
        return "alert";
      case "comment":
        return "comment";
      default:
        return "info";
    }
  }

  get headlineTheme() {
    let color = this.instance["background"];
    return color == "black" ? "secondary" : "default";
  }
}
